import apiClient from "../apiClient";

const suspendOutlet = (data) => apiClient.post("/admin/suspend-outlet", data);

const enableOutlet = (data) => apiClient.post("/admin/unsuspend-outlet", data);

const deleteOutlet = (data) =>
  apiClient.delete("/admin/outlet", { data: data });

const acceptOnboardingOutlet = (data) =>
  apiClient.post("/admin/verify-outlet", data);

const fetchWeeklyPayments = (data) =>
  apiClient.post("/admin/payments-outlet", data);

const cancelOrder = (data) => apiClient.post("/admin/admin-cancel-order", data);

const driverSearch = (data) =>
  apiClient.post("/admin/admin-driver-search", data);

const assignDriver = (data) =>
  apiClient.post("/admin/admin-assign-driver", data);

const saveUrbanPiperKey = (data) =>
  apiClient.put("/admin/outlet-urbanpiper-key", data);

const setupUrbanPiper = (data) =>
  apiClient.post("/admin/setup-outlet-urbanpiper", data);

export default {
  suspendOutlet,
  enableOutlet,
  deleteOutlet,
  acceptOnboardingOutlet,
  fetchWeeklyPayments,
  cancelOrder,
  driverSearch,
  assignDriver,
  saveUrbanPiperKey,
  setupUrbanPiper,
};
